import React, { useState } from "react";
import { Button, Form, Input, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/providers/auth";
import { handleErrors } from "helpers/api";
import AuthLayout from "components/AuthLayout";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [is_loading, setLoading] = useState(false);
  const { handleResetPassword } = useAuth();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const message = await handleResetPassword(values);
      notification.success({
        message,
      });
      navigate("/");
    } catch (error) {
      notification.error({ message: handleErrors(error) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Przypomnij hasło">
      <div className="auth-page__form">
        <Form
          name="basic"
          initialValues={{
            email: "",
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="E-mail"
            name="email"
            hasFeedback
            rules={[
              {
                type: "email",
                message: "Niepoprawny e-mail",
              },
              {
                required: true,
                message: "Email jest wymagany!",
              },
              {
                max: 128,
                message: "Przekroczono maksymalną ilość znaków!",
              },
            ]}
          >
            <Input placeholder="Adres e-mail" maxLength={128} />
          </Form.Item>
          <Button
            loading={is_loading}
            disabled={is_loading}
            type="primary"
            htmlType="submit"
            size="large"
            block
          >
            Wyślij
          </Button>
        </Form>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
